/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import ReactTooltip from 'react-tooltip';
import { Link } from 'react-router-dom';

class HeaderDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
    };
    this.showMenu = this.showMenu.bind(this);
  }

  componentWillUpdate() {
    (this.props.showProductLink !== "/" || !this.props.pathContains)
	  && this.state.showMenu
      && this.setState({
        showMenu: false,
      });
  }

  showMenu() {
    this.setState((prevState) => ({
      showMenu: !prevState.showMenu,
    }));
  }

  render() {
    const menu = this.props.data.menu.items;
    return (
    // <!-- Product dropdown desktop starts -->
      <>
        <ul className="navbar-nav ml-auto product-dropdown-desktop">
          {menu.map((item) => (
            <React.Fragment key={item.title}>
              {/* Products starts */}
              { item.title === 'Products'
                ? (
                  (this.props.showProductLink === "/" || !this.props.pathContains) && (
                  <li className="nav-item dropdown position-static pr-2">
                    <Link
                      className="nav-link"
                      to={item.url}
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      onMouseEnter={this.showMenu}
                    >
                      {item.title}
                      &nbsp;
                      <i className="fa fa-chevron-down product-arrow" />
                    </Link>
                    <div
                      className={`dropdown-menu mt-0 w-100 shadow border-outline-success
                       product-dropdown-desktop-container ${this.state.showMenu ? "show" : ""}`}
                      aria-labelledby="navbarDropdown"
                      onMouseLeave={this.showMenu}
                    >
                      <div className="container">
                        <div className="row product-dropdown-desktop-row">
                          {item.child_items.map((child) => (
                            <React.Fragment key={child.title}>
                              <div className="col-2 dropdown-item product-dropdown-desktop-item">
                                <ul className="list-group product-dropdown-desktop-listgrp">
                                  <p>{child.title.toUpperCase()}</p>
                                  {child.child_items.map((sub) => (
                                    <li className="list-group-item" key={sub.title}>
                                      {(sub.url.indexOf('http://') === 0 || sub.url.indexOf('https://') === 0)
                                        ? <a href={sub.url} data-tip data-for={`productTooltip${sub.title}`}>{sub.title}</a>
                                        : <Link to={sub.url} data-tip data-for={`productTooltip${sub.title}`}>{sub.title}</Link>}
                                      <ReactTooltip
                                        id={`productTooltip${sub.title}`}
                                        className="tooltip-inner"
                                        backgroundColor="#fafafa"
                                        textColor="#000"
                                      >
                                        {sub.full_title}
                                      </ReactTooltip>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    </div>
                  </li>
                  )
                )
                : (
                  <>
                    <li className="nav-item pr-2">
                      {(item.url.indexOf('http://') === 0 || item.url.indexOf('https://') === 0)
                        ? <a className="nav-link" href={item.url}>{item.title}</a>
                        : <Link className="nav-link" to={item.url}>{item.title}</Link>}
                    </li>
                  </>
                )}
            </React.Fragment>
          ))}
        </ul>
      </>
    // <!-- Product dropdown desktop ends -->
    );
  }
}

export default HeaderDesktop;
